function decodeQueryValue(value: string): string {
  try {
    return decodeURIComponent(value.replace(/\+/g, ' '))
  }
  catch {
    return value
  }
}

function findChannelQuery(url: string): string | undefined {
  const queryIndex = url.indexOf('?')
  if (queryIndex < 0)
    return undefined
  for (const pair of url.slice(queryIndex + 1).split('&')) {
    const separator = pair.indexOf('=')
    const key = separator < 0 ? pair : pair.slice(0, separator)
    if (decodeQueryValue(key) === 'channelId')
      return decodeQueryValue(separator < 0 ? '' : pair.slice(separator + 1))
  }
  return undefined
}

export function readChannelId(url: string): string | undefined {
  const hashIndex = url.indexOf('#')
  if (hashIndex < 0)
    return findChannelQuery(url)
  return findChannelQuery(url.slice(hashIndex + 1)) ?? findChannelQuery(url.slice(0, hashIndex))
}

export function appendChannelId(url: string, channelId: string): string {
  if (!channelId || readChannelId(url) !== undefined)
    return url
  const hashIndex = url.indexOf('#')
  const path = hashIndex < 0 ? url : url.slice(0, hashIndex)
  const hash = hashIndex < 0 ? '' : url.slice(hashIndex)
  const separator = path.includes('?') ? (/[?&]$/.test(path) ? '' : '&') : '?'
  return `${path}${separator}channelId=${encodeURIComponent(channelId)}${hash}`
}
